export default __webpack_public_path__ + "static/media/airstrapz-blk-2.eb1a7a34.png";